{
  "error": "Ошибка",
  "forbidden": "Нет доступа",
  "goToMain": "Перейти на главную",
  "logout": "Выйти из личного кабинета",
  "notEnoughRights": "Недостаточно прав для просмотра страницы",
  "pageDoesNotExist": "Такой страницы не существует",
  "siteSleep": "Сайт устал и отдыхает.",
  "thereIsNoPage": "Такой страницы нет",
  "tryGoToMain": "Попробуйте вернуться на главную и повторить действие",
  "tryRelogin": "Попробуйте авторизоваться заново или вернуться на главную и повторить действие.",
  "wrongLink": "Ссылка, по которой вы перешли, никуда не ведет. Возможно, в ней была опечатка, или эта страница была удалена."
}
